import { ConfirmationUploadType } from "./confirmationUploadCsv"

export interface ConfirmationUploadColumn {
    header: string
    mandatory: boolean
}

interface SourceColumn {
    header: string
    mandatory?: boolean
    mandatoryForMaterials?: boolean
}

const SOURCE_COLUMNS: readonly SourceColumn[] = [
    { header: "Transport order", mandatory: true },
    { header: "Ship from DUNS", mandatoryForMaterials: true },
    { header: "Not used" },
    { header: "Ship from ZIP" },
    { header: "Ship from name" },
    { header: "Ship to ZIP" },
    { header: "Ship to country" },
    { header: "Not used" },
    { header: "Not used" },
    { header: "Carrier name", mandatory: true },
    { header: "Carrier DUNS", mandatory: true },
    { header: "License plate", mandatory: true },
    { header: "Trailer license plate" },
    { header: "Not used" },
    { header: "Confirmed pick up date from", mandatory: true },
    { header: "Confirmed pick up date to", mandatory: true },
    { header: "Not used" },
    { header: "Transport chain reference" },
    { header: "LKW Control ID" },
    { header: "Via hub" },
]

const columnsFor = (uploadType: ConfirmationUploadType): readonly ConfirmationUploadColumn[] =>
    SOURCE_COLUMNS.map(column => ({
        header: column.header,
        mandatory: column.mandatory === true ||
            (column.mandatoryForMaterials === true && uploadType === "MATERIAL"),
    }))

export const MATERIAL_CONFIRMATION_COLUMNS = columnsFor("MATERIAL")
export const EMPTIES_CONFIRMATION_COLUMNS = columnsFor("EMPTIES")

export interface ConfirmationUploadTemplate {
    content: string
    fileName: string
}

export const createConfirmationUploadTemplate = (uploadType: ConfirmationUploadType): ConfirmationUploadTemplate => {
    const columns = uploadType === "MATERIAL" ? MATERIAL_CONFIRMATION_COLUMNS : EMPTIES_CONFIRMATION_COLUMNS
    const content = columns
        .map(column => `${column.header}${column.mandatory ? "*" : ""}`)
        .join(";") + "\n"

    return {
        content,
        fileName: uploadType === "MATERIAL"
            ? "material-confirmation-template.csv"
            : "empties-confirmation-template.csv",
    }
}
